import React, { createContext, useReducer } from 'react';
import { modalStateReducer } from './reducer';

export const ModalStateContext = createContext();
export const ModalDispatchContext = createContext();

export const ToggleModalsVisibleProvider = ({ children }) => {
  const [state, dispatch] = useReducer(modalStateReducer, {});

  return (
    <ModalStateContext.Provider value={state}>
      <ModalDispatchContext.Provider value={dispatch}>
        {children}
      </ModalDispatchContext.Provider>
    </ModalStateContext.Provider>
  );
};
